import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "remixicon/fonts/remixicon.css";

const TentativeFamilyPlanForm = ({ formData, handleChange }) => {
  return (
    <div className="p-4">
      {/* ================= CLIENT INFORMATION ================= */}
      <div className="row mb-3">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Client Information & Meetings
        </small>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="text"
              name="clientName"
              className="form-control"
              value={formData?.clientName || ""}
              onChange={handleChange}
              placeholder="Client Name"
              required
              readOnly={!!formData?.patientId} // ⭐ ADD THIS PROPERTY TO LOCK INPUT BOX ⭐
            />
            <label>Client Name</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="date"
              name="dateOfAdmission"
              className="form-control"
              value={formData?.dateOfAdmission || ""}
              onChange={handleChange}
              required
            />
            <label>Date of Admission</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="date"
              name="historyTakingMeeting"
              className="form-control"
              value={formData?.historyTakingMeeting || ""}
              onChange={handleChange}
            />
            <label>History Taking Meeting</label>
          </div>
        </div>

        <div className="col-md-3">
          <div className="form-floating form-floating-outline mb-3">
            <input
              type="date"
              name="firstCallWithFamily"
              className="form-control"
              value={formData?.firstCallWithFamily || ""}
              onChange={handleChange}
            />
            <label>First Call with Family</label>
          </div>
        </div>

        {/* Communication */}
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Communication
        </small>
        <div className="col-12">
          <div className="form-floating form-floating-outline mb-3">
            <textarea
              name="callSchedule"
              className="form-control"
              value={formData?.callSchedule || ""}
              onChange={handleChange}
              placeholder="Call Schedule"
              style={{ height: "80px" }}
            ></textarea>
            <label>Call Schedule (Frequency & Timing)</label>
          </div>
        </div>

        <div className="col-12">
          <div className="form-floating form-floating-outline mb-3">
            <textarea
              name="monthlyFamilyMeeting"
              className="form-control"
              value={formData?.monthlyFamilyMeeting || ""}
              onChange={handleChange}
              placeholder="Monthly Family Meeting"
              style={{ height: "80px" }}
            ></textarea>
            <label>Monthly Family Meeting Schedule</label>
          </div>
        </div>

        <div className="col-12">
          <div className="form-floating form-floating-outline mb-3">
            <textarea
              name="familyClientMeeting"
              className="form-control"
              value={formData?.familyClientMeeting || ""}
              onChange={handleChange}
              placeholder="Family & Client Meeting"
              style={{ height: "80px" }}
            ></textarea>
            <label>Family & Client Meeting Arrangements</label>
          </div>
        </div>
      </div>

      {/* ================= ACTIVITIES ================= */}
      <div className="row mb-3">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Activities & Home Integration
        </small>

        <div className="col-12">
          <div className="form-floating form-floating-outline mb-3">
            <textarea
              name="outings"
              className="form-control"
              value={formData?.outings || ""}
              onChange={handleChange}
              placeholder="Outing Plans"
              style={{ height: "80px" }}
            ></textarea>
            <label>Outings Plan</label>
          </div>
        </div>
      </div>

      {/* ================= VISITS ================= */}
      <div className="row mb-3">
        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
          Visits & Stays
        </small>

        {[
          { name: "homeVisit", label: "Home Visit" },
          { name: "nightStay", label: "Night Stay" },
          { name: "weekendStay", label: "Weekend Stay" },
        ].map((item, index) => (
          <React.Fragment key={index}>
            <div className="col-md-4">
              <div className="form-floating form-floating-outline mb-3">
                <select
                  name={item.name}
                  className="form-select"
                  value={formData[item.name]}
                  onChange={handleChange}
                >
                  <option value="">Select {item.label} Status</option>
                  <option value="Planned">Planned</option>
                  <option value="Completed">Completed</option>
                  <option value="Pending">Pending</option>
                  <option value="Not Applicable">Not Applicable</option>
                </select>
                <label>{item.label}</label>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating form-floating-outline mb-3">
                <input
                  type="date"
                  name={`${item.name}Date`}
                  className="form-control"
                  value={formData[`${item.name}Date`]}
                  onChange={handleChange}
                />
                <label>{item.label} Date (if planned)</label>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TentativeFamilyPlanForm;
